import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import "../styles/sidebar.css";

import BRAND_LOGO from '../images/home-logo.png';

import Card1 from '../images/Card1.png';
import Card2 from '../images/Card2.png';
import Card3 from '../images/Card3.png';

import Card2_Hover from '../images/Card2-Hover.png';
import Card3_Hover from '../images/Card3-Hover.png';

import { webURL, card1Text, card2Text, card3Text } from '../config';

import { fetchUser } from '../redux/actions/fetchUser';


const SideBar = () => {  
    const dispatch = useDispatch();    
    const userEmail = localStorage.getItem('email');

    // update user role periodically every minute
    useEffect(() => {
      const fetchData = () => {
        dispatch(fetchUser(userEmail));
      };
    
      // Fetch data initially
      fetchData();
    
      // Set interval to fetch data periodically (e.g., every minute)
      const intervalId = setInterval(fetchData, 1 * 60 * 1000);
    
      // Clear interval on component unmount
      return () => clearInterval(intervalId);
    }, [userEmail, dispatch]);    

    return (
    
      <ul className='sidebar-ul'>         
          <div className='sidebar-ul-img-container'>
            <img  src={BRAND_LOGO} alt='AOL' className='sidebar-ul-img'/>
          </div>

        <div className='sidebar-ul-card-container'>
          <li className='sidebar-ul-card-li'>
              <Card className='sidebar-ul-card'>
                <Card.Body className='sidebar-ul-card-body'>
                  <Card.Img variant="top" src={Card1} className='sidebar-card-image' />
                  <Card.Text className='card-text'>
                   {card1Text}
                  </Card.Text>
                  <a href={webURL} target='_blank' rel='noreferrer' className='sidebar-ul-card-btn-container'>
                    <button variant="text" className='card-btn' >Learn More</button>
                  </a>              
                </Card.Body>
            </Card>
            </li>

            <li className='sidebar-ul-card-li'>
              <Card className='sidebar-ul-card'>            
                <Card.Body className='sidebar-ul-card-body'>
                  <div className='images-container-detect-count-reID'>            
                    <Card.Img variant="top" src={Card2} className='shogun-img'/>
                    <Card.Img variant="top" src={Card2_Hover} className='shogun-img-hover'/>
                  </div>
                  <Card.Text className='card-text'>
                  {card2Text}
                  </Card.Text>
                  <a href={webURL} target='_blank'rel='noreferrer' className='sidebar-ul-card-btn-container'>
                    <button className='card-btn'  >Learn More</button>
                  </a>
                </Card.Body>
              </Card>
            </li>

            <li className='sidebar-ul-card-li'>
              <Card className='sidebar-ul-card'>            
                <Card.Body className='sidebar-ul-card-body'>
                  <div className='images-container-ronin-hm'> 
                    <Card.Img variant="top" src={Card3} className='ronin-img'/>
                    <Card.Img variant="top" src={Card3_Hover} className='ronin-img-hover'/>
                  </div>    
                  <Card.Text className='card-text'>
                  {card3Text}
                  </Card.Text>          
                  <a href={webURL} target='_blank'rel='noreferrer' className='sidebar-ul-card-btn-container'>
                    <button variant="text" className='card-btn' >Learn More</ button>
                  </a>
                </Card.Body>
              </Card>
            </li>
        </div>        
      </ul>
  );
};

export default SideBar;
